<template>
    <div class="logs">
      <el-dialog
        :show-close="false"
        fullscreen=""
        :visible.sync="logsModal"
        width="515px">
        <template slot="title">
          <div class="modal-title acr-bold-22">
            <div>
              <div class="modal-btn" @click="logsModal = false;selectedProcess=null">
                <svgicon name="Chevron-left"></svgicon>
              </div>
              <span style="margin-top: -1px" v-if="selectedProcess">
                Process #{{selectedProcess.id}}&nbsp;- {{selectedProcess.project_name}}
                <a href="#" @click="downloadTxt(selectedProcess.logs_url, selectedProcess.project_name)">Download logs</a>
              </span>
            </div>
          </div>
        </template>
        <div class="modal-field" style="white-space: pre-line;font-family: monospace, monospace;">
          <p v-if="selectedProcess">
            {{selectedMessages}}
          </p>
        </div>
      </el-dialog>
      <div class="logs-table">
        <div class="logs-table-item logs-table-item--heading">
          <div class="logs-add-project">
            <!--<svgicon name="Plus" style="width: 18px;height: 18px"></svgicon>-->
            <span class="acr-ultra-bold">Process status</span>
          </div>
        </div>
        <div class="content-wrapper">
          <div class="logs-table-item" v-for="item in processes" :key="item.id" :class="{'in-progress': item.status !== 100}">
            <div class="logs-table-item__name">
              <span>
                <div class="logs-status" v-if="item.status === 100">
                  <svgicon name="Done"></svgicon>
                </div>
                <div class="pie-chart" :style="{'background': `${piePercent(item.status)}`}" v-else></div>
              </span>
              Process #{{item.id}}&nbsp;- {{item.project_name}}&nbsp;
              <span class="logs-table-item__status">({{item.error_during_processing ? '1': '0'}} errors)</span>
            </div>
            <span>
              <a href="#" @click="showMessages(item)">Show messages</a>
              <a href="#" @click="downloadTxt(item.logs_url, item.project_name)">Download logs</a>
            </span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { getProjectLogs } from "../../api/projects";

export default {
  name: "Logs.vue",
  data() {
      return {
        logsModal: false,
        selectedProcess: null,
        selectedMessages: null,
        processes: []
      }
  },
  created() {
    getProjectLogs().then((res) => {
      this.processes = res.data.projects;
    });
  },
  mounted() {
    this.$socket.on('project-logs-sender', (e, data) => {
      if (data.id === this.selectedProcess.id) {
        this.selectedMessages += ' ' + data.message + '\n';
      }
      console.log(e, data);
    })
  },
  methods: {
    downloadTxt(url, filename) {
      fetch(url).then((t) => {
        return t.blob().then((b) => {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(b);
            a.setAttribute("download", 'log_' + filename.split(' ').join('_') + '.txt');
            a.click();
          }
        );
      });
    },
    showMessages(item) {
      this.selectedProcess = item;
       this.displayTxt(item.logs_url).then((txt) => {
         this.selectedMessages = txt.replace(/&lt;/g, "<");
         this.logsModal = true;
      });
    },
    displayTxt(url) {
      if (!this.isValidHttpUrl(url)) return new Promise(resolve => resolve(JSON.parse(url)));
      return fetch(url).then((txtFile) => txtFile.text());
    },
    isValidHttpUrl(string) {
      let url;

      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }

      return url.protocol === "http:" || url.protocol === "https:";
    },
    piePercent(percent) {
      return `radial-gradient(
        circle closest-side,
        transparent 66%,
        white 0
    ),
    conic-gradient(
        #9BC225 0,
        #9BC225 ${percent}%,
        rgba(0,0,0,.1) 0,
        rgba(0,0,0,.1) 100%
    )`
    },
  },
}
</script>

<style scoped>

</style>
